
import { View } from "../view";
import { Template, LazyTemplate } from "../template/index";
import ActionBar from "./index";

/** Enum containing all the available action bar item groups. */
export enum ActionBarItemGroup
{
    LEFT = 'left',
    RIGHT = 'right'
}

/** Constructor type that creates an ActionBarItem. */
export interface ActionBarItemConstructor
{
    new (actionBar: ActionBar): ActionBarItem;
}

/** Abstract base implementation of an action bar item. */
export abstract class ActionBarItem extends View
{
    protected actionBar: ActionBar;

    /**
     * Group where the action bar item lies.
     */
    public group: ActionBarItemGroup = ActionBarItemGroup.LEFT;

    constructor(actionBar: ActionBar)
    {
        super();
        this.actionBar = actionBar;
    }

    public afterRender(): PromiseLike<void>
    {
        this.element.addEventListener('click', (e) => 
        {
            this.trigger('click', e);
            this.onClick(e);
        });

        return super.afterRender();
    }

    protected onClick(e: MouseEvent): void
    {
        this.actionBar.collapse();
    }

    public remove()
    {
        return this.unload().then(() =>
        {
            this.element.parentElement.removeChild(this.element);
        });
    }
}

/** Base implementation of an action bar button. */
export class ActionBarButton extends ActionBarItem
{
    protected iconClassList = '';
    protected title = '';
    
    /** Optional hash where the app is routed when the button is clicked. */
    public hash: string;

    public template: LazyTemplate = Template.inline(`
    <button class="item button no-button-styles"><span class="title">{{=it.title}}</span><i class="icon {{=it.iconClassList}}"></i></button>
    `);

    public onClick(e: MouseEvent)
    {
        super.onClick(e);
        
        if (this.hash !== undefined)
        {
            window.location.hash = this.hash;
        }
    }
}


export class FullScreenButton extends ActionBarButton
{
    public group = ActionBarItemGroup.RIGHT;
    public template: LazyTemplate = Template.inline(`
    <button class="item button"><i class=""></i>{{=it.content}}</button>
    `);

    public get isFullscreen(): boolean 
    { 
        let result = (document.fullscreenElement && document.fullscreenElement !== null) ||
            (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
            ((<any>document).mozFullScreenElement && (<any>document).mozFullScreenElement !== null) ||
            ((<any>document).msFullscreenElement && (<any>document).msFullscreenElement !== null);

        return result;
    }

    private iconElement: HTMLElement;

    public afterRender(): PromiseLike<void>
    {
        this.iconElement = <HTMLElement>this.element.querySelector('.icon');
        this.iconClassList = this.isFullscreen ? 'icon-shrink' : 'icon-enlarge';
        return super.afterRender();
    }
    protected toggleFullscreen()
    {
        let documentElement = <any>document.documentElement;

        if (!this.isFullscreen) 
        {
            if (documentElement.requestFullscreen) 
            {
                documentElement.requestFullscreen();
            } 
            else if (documentElement.mozRequestFullScreen) 
            {
                documentElement.mozRequestFullScreen();
            } 
            else if (documentElement.webkitRequestFullScreen) 
            {
                documentElement.webkitRequestFullScreen();
            } 
            else if (documentElement.msRequestFullscreen) 
            {
                documentElement.msRequestFullscreen();
            }


            this.iconClassList = 'icon-shrink';
            this.element.querySelector('.icon')
            //this.setProperty_NOT('iconCl.assList', 'icon im-shrink')
        } 
        else 
        {
            if (document.exitFullscreen) 
            {
                document.exitFullscreen();
            } 
            else if (document.webkitExitFullscreen) 
            {
                document.webkitExitFullscreen();
            } 
            else if ((<any>document).mozCancelFullScreen) 
            {
                (<any>document).mozCancelFullScreen();
            } 
            else if ((<any>document).msExitFullscreen) 
            {
                (<any>document).msExitFullscreen();
            }

            this.iconClassList = 'icon-enlarge';
            ///this.setProperty_NOT('iconClassList', 'icon im-enlarge')
        }
    }

    public onClick(): void
    {
        this.toggleFullscreen();
    }
}